import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { StampHistoryRow } from '@models/stamp';
import dayjs from 'dayjs';

import styles from './styles.module.scss';

interface Props {
    stampHistory: StampHistoryRow;
}

function StampLogRow({ stampHistory }:Props) {
  const {
    shopName, eventType, occurredAt, stampCount,
  } = stampHistory;
  return (
        <Column fullWidth spacing={4}>
            <Text size='lg' color={colors.white} fontWeight='medium'>
                {shopName}
            </Text>
            <Text color={colors.white}>
                {dayjs(occurredAt).format('YYYY.MM.DD.')}
            </Text>
            <Row fullWidth className={styles.type}
                 spacing={20}
                 justify='flex-end'>
                <Text size='xl' color={colors.white}>
                    {eventType === 'ISSUED' ? '+' : '-'}
                </Text>
                <Text size='xl' color={colors.white} fontWeight='bold'>
                    {stampCount}개
                </Text>
            </Row>
        </Column>
  );
}

export default StampLogRow;
